import { isAutomatedTest } from 'core/lib/isAutomatedTest';
import { pushGaCommandToDataLayer } from './lib/trackAnalyticsEvent';
import { shouldSendDirectPlatformTracking } from './lib/dataLayer';

function shouldTrack(trackInAutomatedTest: boolean): boolean {
    if (trackInAutomatedTest) {
        return true;
    }

    if (isAutomatedTest()) {
        // eslint-disable-next-line no-console
        console.log(
            'automated test detected - skipping Google Analytics tracking',
        );
        return false;
    }

    return true;
}

export function trackWithGoogleAnalytics4(
    trackInAutomatedTest: boolean,
    cmd: string,
    ...args: unknown[]
): void {
    if (shouldTrack(trackInAutomatedTest)) {
        pushGaCommandToDataLayer(cmd, ...args);
    }

    if (!shouldSendDirectPlatformTracking()) {
        return;
    }

    if (shouldTrack(trackInAutomatedTest)) {
        // if we have `window.gtag` available, it means
        // we have GA4. we need this in cases where
        // we don't have access to useStaticQuery
        try {
            window.gtag?.(cmd, ...args);
        } catch (error) {
            console.warn(
                'error submitting GA4 command',
                (error as Error).message,
            );
        }
    }
}
